export default __webpack_public_path__ + "static/media/ro.9b3ae9b1.svg";